export default {
  'ticket.operator': 'Operatore',
  'ticket.status': 'Stato',
  'ticket.lastupdate': 'Ultimo Aggiornamento',
  'ticket.ticketid': 'ID Biglietto',
  'ticket.subject': 'Soggetto',
  'ticket.total': 'Totale Biglietti',
  'ticket.notassigned': 'Non Assegnato',
  'ticket.addnewticket': 'Nuovi Biglietti',
  'ticket.search': 'Cerca',
  'ticket.myticket': 'Mio Biglietto',
  'ticket.knowleadgebase': 'Base di conoscenza',
  'ticket.announcements': 'Annunci',
  'ticket.description': 'Descrizioni',
  'ticket.mytickets': 'Mio Biglietto',
  'ticket.knowledgebase': 'Base di conoscenza',
  'ticket.announcements': 'Annunci',
  'ticket.all': 'Tutto',
  'ticket.done': 'Fatto',
  'ticket.inprogress': 'In corso',
  'ticket.new': 'Nuovo',
  'ticket.ticketsInbox': 'Posta in arrivo',
  'ticket.ticketsUnread': 'Non letto(2)',
  'ticket.sender': 'Mittente',
  'ticket.findtickets': 'Cerca Biglietti',
  'ticket.newticket': 'Nuovi Biglietti',
  'ticket.text': 'Testo',
  'ticket.insertSubject': 'Inserisci l oggetto della tua richiesta',
  'ticket.insertText': 'Si prega di inserire il testo della richiesta',
  'ticket.insertMessageAndSubject':
    'Inserisci l oggetto e il testo della tua richiesta',
  'ticket.details': 'Particolari',
  'ticket.reply': 'Risposta',
  'ticket.dateoforder': "Data dell'ordine",
  'ticket.dateoftravel': 'Data del viaggio',
  'ticket.item': 'Elemento',
  'ticket.submitinwriting': 'Presentare per iscritto',
  'ticket.send': 'inviare',
  'ticket.attachphoto':
    'In questa parte della sezione richieste è possibile caricare la foto desiderata tramite il link sottostante.',
};
